import React from "react";
import { getStatusMeta } from "./reportingStyles";

function ProgressBar({ value = 0, status, width = "w-16" }) {
  const pct = Math.min(100, Math.max(0, Math.round(value)));
  const color = status ? getStatusMeta(status).dot : "#4F46E5";

  return (
    <div className="flex items-center gap-2" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
      <div className={`h-1.5 ${width} overflow-hidden rounded-full bg-slate-100`}>
        <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
      <span className="w-8 text-right text-[11px] font-medium tabular-nums text-slate-500">{pct}%</span>
    </div>
  );
}

export default ProgressBar;